const Philosophy = () => {
  return <section id="philosophy" className="section-padding bg-gradient-to-b from-background to-secondary/20">
      <div className="container-custom animate-fade-in">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-8">Unsere Philosophie</h2>
          
          <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
            <p>
              Unsere Vision ist es, Unternehmen dabei zu helfen, zu wachsen, passende Zielgruppen zu erreichen und sichtbar zu machen, was sie wirklich ausmacht.
            </p>
            
            <p>
              Ob Fotografie, Filmproduktion oder Social Media – wir glauben daran, dass echte Wirkung nur entsteht, wenn sie authentisch ist. Deshalb erfinden wir keine Geschichten, sondern zeigen, was wirklich da ist: Leidenschaft, Persönlichkeit und Herz.
            </p>
            
            <p>
              Wir begleiten Sie nicht nur hinter der Kamera, sondern auch davor. Wir zeigen Ihnen, wie Sie souverän auftreten, wie Sie Inhalte erschaffen, die berühren und bewegen.
            </p>
            
            <p>
              Als kleines, eingespieltes Team legen wir größten Wert auf Qualität – nicht auf Masse. Jeder Auftrag ist für uns ein gemeinsames Projekt, bei dem wir alles geben, um aus Ihrer Marke eine Geschichte zu machen, die man nicht vergisst.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Philosophy;